/**
 * GeometricLoader — System Labs themed loading indicator.
 *
 * 3×6 grid of cells that pulse with a diagonal-wave delay, echoing the
 * peptide-chain / halftone motif used elsewhere in the brand. Mono,
 * uses currentColor — wrap in any text-color class to recolor.
 */

const ROWS = 3;
const COLS = 6;

export function GeometricLoader({ label = 'Loading' }: { label?: string }) {
  const cells = [];
  for (let r = 0; r < ROWS; r++) {
    for (let c = 0; c < COLS; c++) {
      const delay = ((r + c) % (ROWS + COLS - 1)) * 0.08;
      cells.push(
        <span
          key={`${r}-${c}`}
          className="sl-loader-cell"
          style={{ animationDelay: `${delay}s` }}
        />,
      );
    }
  }

  return (
    <div role="status" aria-live="polite" className="inline-flex flex-col items-center gap-15">
      <div aria-hidden className="sl-loader-grid">
        {cells}
      </div>
      <span className="sr-only">{label}</span>
      <style>{`
        .sl-loader-grid {
          display: grid;
          grid-template-columns: repeat(${COLS}, 8px);
          grid-template-rows: repeat(${ROWS}, 8px);
          gap: 3px;
        }
        .sl-loader-cell {
          width: 8px;
          height: 8px;
          background: currentColor;
          opacity: 0.15;
          animation: slLoaderPulse 1.2s ease-in-out infinite;
        }
        @keyframes slLoaderPulse {
          0%, 70%, 100% {
            opacity: 0.15;
            transform: scale(1);
          }
          35% {
            opacity: 1;
            transform: scale(1.15);
          }
        }
        .sr-only {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          white-space: nowrap;
          border: 0;
        }
      `}</style>
    </div>
  );
}
